import React from "react";
import "../../animation/anima.css";
import { HiVideoCamera } from "react-icons/hi2";

import heroImage from "../../assets/images/hero/hero-img.png";
import heroUserOne from "../../assets/images/hero/hero-user-1.png";
import heroUserTwo from "../../assets/images/hero/hero-user-2.png";
import heroUserThree from "../../assets/images/hero/hero-user-3.png";
import curveArrow from "../../assets/images/hero/curve-arrow.svg";

const LandingHero = () => {
    return (
        <section className="">
            <div className="bg-sectionBackground">
                <div className="pt-40 pb-16 md:pb-28">
                    <div className="container mx-auto md:px-14 px-8">
                        <div className="relative z-10 grid grid-cols-1 items-center justify-center gap-x-[90px] gap-y-16 lg:grid-cols-[1fr_minmax(0,0.6fr)]">
                            <div className="text-center text-colorButteryWhite lg:text-start">
                                <h1 className="text-3xl md:text-5xl lg:text-7xl font-semibold">
                                    Build your{" "}
                                    <span className="inline-flex items-center text-4xl md:text-6xl lg:text-8xl font-extrabold">
                                        <span className="text-prime">
                                            &#123;
                                        </span>
                                        <span>software</span>
                                        <span className="text-prime">
                                            &#125;
                                        </span>
                                    </span>{" "}
                                    products, Faster. Better.
                                </h1>
                                <p className="mb-10 mt-6 text-lg leading-[1.4] md:mb-14 lg:text-[21px]">
                                    We're a trusted web and mobile app
                                    development agency with expertise in{" "}
                                    <span className="font-semibold">
                                        SaaS, Media, Marketing Tech, and AI
                                        development.
                                    </span>{" "}
                                    Whether you're a startup, an agency, or a
                                    big company, we've got you covered.
                                </p>

                                <div className="mb-12 flex flex-wrap items-center justify-center gap-4 lg:justify-start">
                                    <div className="flex -space-x-3">
                                        <img
                                            src={heroUserOne}
                                            alt="hero-user-1"
                                            className="z-0 h-16 w-16 rounded-[50%] border-2 border-prime shadow-md"
                                        />
                                        <img
                                            src={heroUserTwo}
                                            alt="hero-user-2"
                                            className="z-0 h-16 w-16 rounded-[50%] border-2 border-prime shadow-md"
                                        />
                                        <img
                                            src={heroUserThree}
                                            alt="hero-user-3"
                                            className="z-0 h-16 w-16 rounded-[50%] border-2 border-prime shadow-md"
                                        />
                                    </div>
                                    <span className="text-base font-semibold">
                                        Trusted by people around the world
                                    </span>
                                </div>
                                <div className="grid xl:grid-cols-2 grid-cols-1">
                                    <div className="flex flex-col items-center">
                                        <span className="pb-3 text-center">
                                            Experience how our software
                                            development framework and agile
                                            processes speed up the development
                                            cycle.
                                        </span>
                                        <a
                                            className="items-center bg-prime rounded-full px-6 py-3 shadow-xl text-sectionBackground md:text-2xl text-xl font-bold inline-grid grid-flow-col gap-5"
                                            href="/contact"
                                        >
                                            <span>
                                                Book A Free Consultation
                                            </span>
                                            <span className="rounded-full bg-sectionBackground text-5xl">
                                                <HiVideoCamera className="text-prime p-2" />
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="mx-auto sm:inline-block hidden">
                                <img
                                    src={heroImage}
                                    alt="hero-img"
                                    className="h-full w-full"
                                />
                            </div>

                            <img
                                src={curveArrow}
                                alt="curve-arrow"
                                width="450"
                                height="100"
                                className="absolute bottom-0 left-1/2 -z-10 hidden h-auto max-w-52 -translate-x-56 translate-y-8 rotate-3 xl:inline-block xl:max-w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LandingHero;
